import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatTestPanelMapping as creatTestPanelMappingApi,
    updateTestPanelMapping as updateTestPanelMappingApi,
    getAllTestPanelMapping as getAllTestPanelMappingApi,
    getTestPanelMapping as getTestPanelMappingApi,
    getTestPanelsListing as getTestPanelsListingApi,
} from './api';

// actions
import { testPanelMappingApiResponseSuccess, testPanelMappingApiResponseError } from './actions';

// constants
import { TestPanelMappingActionTypes } from './constants';

type TestPanelMappingData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Test Mapping
 * @Panel {*}
 */
function* addTestPanelMapping({ payload, type }: TestPanelMappingData): SagaIterator {
    try {
        const response = yield call(creatTestPanelMappingApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.ADD_TEST_PANEL_MAPPING,
                    data,
                    'Test Mapping has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Test Mapping!`;
            if (message) msg = message;
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.ADD_TEST_PANEL_MAPPING,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testPanelMappingApiResponseError(
                TestPanelMappingActionTypes.ADD_TEST_PANEL_MAPPING,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Edit Test Mapping
 * @Panel {*}
 */
function* editTestPanelMapping({ payload, type }: TestPanelMappingData): SagaIterator {
    try {
        const response = yield call(updateTestPanelMappingApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.EDIT_TEST_PANEL_MAPPING,
                    data,
                    'Test Mapping Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Test Mapping!`;
            if (message) msg = message;
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.EDIT_TEST_PANEL_MAPPING,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testPanelMappingApiResponseError(
                TestPanelMappingActionTypes.EDIT_TEST_PANEL_MAPPING,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Get Test Mapping
 * @Panel {*}
 */
function* getTestPanelMapping({ payload, type }: TestPanelMappingData): SagaIterator {
    try {
        const response = yield call(getTestPanelMappingApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPING,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Test Mapping!`;
            if (message) msg = message;
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPING,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testPanelMappingApiResponseError(
                TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPING,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Get Test Panel Mappings
 * @Panel {*}
 */
function* getTestPanelMappings({ payload, type }: TestPanelMappingData): SagaIterator {
    try {
        const response = yield call(getAllTestPanelMappingApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPINGS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Test Panel Mapping Listing!`;
            if (message) msg = message;
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPINGS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testPanelMappingApiResponseError(
                TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPINGS,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Get Test Panel Mappings
 * @Panel {*}
 */
function* getTestPanelsListing({ payload, type }: TestPanelMappingData): SagaIterator {
    try {
        const response = yield call(getTestPanelsListingApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.GET_TEST_PANELS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Test Panel Listing!`;
            if (message) msg = message;
            yield put(
                testPanelMappingApiResponseSuccess(
                    TestPanelMappingActionTypes.GET_TEST_PANELS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testPanelMappingApiResponseError(TestPanelMappingActionTypes.GET_TEST_PANELS, [], error, 404, true, false)
        );
    }
}

export function* watchAddTestPanelMapping() {
    yield takeEvery(TestPanelMappingActionTypes.ADD_TEST_PANEL_MAPPING, addTestPanelMapping);
}

export function* watchEditTestPanelMapping() {
    yield takeEvery(TestPanelMappingActionTypes.EDIT_TEST_PANEL_MAPPING, editTestPanelMapping);
}

export function* watchGetTestPanelMapping(): any {
    yield takeEvery(TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPING, getTestPanelMapping);
}

export function* watchGetTestPanelMappings(): any {
    yield takeEvery(TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPINGS, getTestPanelMappings);
}

export function* watchGetTestPanelsListing(): any {
    yield takeEvery(TestPanelMappingActionTypes.GET_TEST_PANELS, getTestPanelsListing);
}

function* testPanelMappingSaga() {
    yield all([
        fork(watchAddTestPanelMapping),
        fork(watchEditTestPanelMapping),
        fork(watchGetTestPanelMapping),
        fork(watchGetTestPanelMappings),
        fork(watchGetTestPanelsListing),
    ]);
}

export default testPanelMappingSaga;
